import { createModelPermissions } from "components/permissions";
import { createPermissionCheck, PERMISSION_ACTIONS, PERMISSION_GROUPS, ENTRY_POINTS } from "components/permissions/utils/permission-utils";

export const VariableConst = {
  ...createModelPermissions({
    modelName: "variable_lists",
    basePath: "/variable-lists",
    permissions: {
      VIEW: true,
      UPDATE: true,
      DELETE: true,
    },
  }),
  permissions: {
    ...createModelPermissions({
      modelName: "variable_lists",
      basePath: "/variable-lists",
      permissions: {
        VIEW: true,
        UPDATE: true,
        DELETE: true,
      },
    }).permissions,
    UPDATE_ITEMS: createPermissionCheck(
      "permission_update_variable_items",
      ENTRY_POINTS.LIBRARY,
      PERMISSION_GROUPS.VARIABLE_LISTS,
      PERMISSION_ACTIONS.UPDATE
    ),
    DELETE_ITEMS: createPermissionCheck(
      "permission_delete_variable_items",
      ENTRY_POINTS.LIBRARY,
      PERMISSION_GROUPS.VARIABLE_LISTS,
      PERMISSION_ACTIONS.DELETE
    ),
    CHANGE_ORDER: createPermissionCheck(
      "permission_change_order",
      ENTRY_POINTS.LIBRARY,
      PERMISSION_GROUPS.VARIABLE_LISTS,
      PERMISSION_ACTIONS.CHANGE
    ),
  },
};

export default VariableConst;